/**
 * An AMD wrapper around underscore.js for loaders (like DOJO) that don't
 * support shims
 */
define(['text!/bower_components/underscore/underscore.js'], function(script){
	(new Function(script))();
	// eslint-disable-next-line no-undef
	return _;
});
